<template>
  <div ref="dropdown">
    <div
      class="floating-input-label multiselect"
      :class="{
        'input-error': needInput,
        visible: visible,
        disabled: disabled,
        required: required,
      }"
      @click="activate"
      :selected-amount="selectedAmount"
    >
      <div class="floating-input-label__input pl-none"></div>
      <label
        class="floating-input-label__label"
        v-text="valueString ? valueString : label"
        :for="fatData.label"
      ></label>
    </div>
    <ul :class="{ 'input-error': needInput, visible: visible }">
      <li v-for="(option, k) in multiselectOptions" :key="k">
        <checkbox
          style="width: 100%"
          @change="updateSelectedOptions(option)"
          :checked="options.checked"
          :label="option.label"
        ></checkbox>
      </li>
    </ul>
  </div>
</template>

<script>
import Checkbox from '@/shared/components/checkbox.vue';

export default {
  name: 'input-multiselect',
  components: { Checkbox },
  props: {
    options: {
      type: Array,
      required: true,
    },
    fatData: Object,
    placeholder: String,
    identifier: String,
    disabled: Boolean,
    name: String,
    label: String,
    multiselectLabel: {
      type: String,
      default: '',
    },
    // requiredMultiselects: Array,
    required: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedAmount: 0,
      selectedOptions: [],
      multiselectOptions: [],
      valueString: this.multiselectLabel,
      needInput: false,
      visible: false,
    };
  },
  methods: {
    observeClicksOutside() {
      document.body.addEventListener('click', (event) => {
        if (this.$refs
          && this.$refs.dropdown
          && event.target !== this.$refs.dropdown
          && !this.$refs.dropdown.contains(event.target)
        ) {
          this.visible = false;
        }
      });
      document.body.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.visible = false;
        }
      });
    },
    updateSelectedOptions(item) {
      if (!this.selectedOptions.includes(item.label)) {
        this.selectedOptions.push(item.label);
      } else {
        this.selectedOptions = this.selectedOptions.filter(
          (x) => x !== item.label,
        );
      }
      this.selectedAmount = this.selectedOptions.length;
      this.$emit('changed');
    },
    mapCheckedToListElements(list) {
      let data = [];
      data = list.map((obj) => ({
        ...obj,
        checked: false,
      }));
      return data;
    },
    activate() {
      this.visible = !this.visible;
    },
  },
  created() {
    this.multiselectOptions = this.mapCheckedToListElements(this.options);
  },
  mounted() {
    this.observeClicksOutside();
  },
  watch: {
    // requiredMultiselects(value) {
    //   this.needInput = value.includes(this.identifier);
    // },
    selectedOptions(value) {
      const computedMultiselectLabel = this.multiselectLabel && value.length ? `${this.multiselectLabel}: ` : '';
      this.valueString = `${computedMultiselectLabel}${value.toString().replace(/,/gi, '; ')}`;
      this.needInput = this.required && this.valueString === computedMultiselectLabel;
      this.$emit('stringedValue', {
        ...this.fatData,
        value,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.floating-input-label.multiselect {
  width: 100%;
  height: 2.625rem;
  border: 0.0625rem solid #ffffff;
  border-radius: 0;
  background-color: #ffffff;
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBjbGFzcz0ic3ZnLWljb24gc3ZnLWljb24tLWFycm93Ij48cGF0aCBkPSJNOS44NzQgMTUuMjQ4bC4yNTYuMjU2IDkuODQ0LTkuODQ0LTEuNDEzLTEuNDEzLTguNDM0IDguNDM2TDEuNDQgMy45OTYuMDI1IDUuNDFsOS44NDQgOS44NDMuMDA0LS4wMDV6IiBmaWxsPSIjMzMzMzMzIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=);
  background-position: calc(100% - 10px) 50%;
  background-repeat: no-repeat;

  padding: 0;
  cursor: pointer;

  &.disabled {
    border: 1px solid white;
    background: lightgrey;
  }

  &.visible {
    border-style: solid;
    border-width: 1px 1px 0 1px;
    border-color: #c8d0d6;
  }
  &.input-error {
    border-style: solid;
    border-width: 1px 1px 1px 1px;
    border-color: #cc3333;
  }
  &.visible.input-error {
    border-width: 1px 1px 0 1px;
  }

  input[type="text"] {
    height: 100%;
    border: none;
    padding-right: rem(35) !important;
    background-color: transparent;

    &:disabled {
      background-color: #d3d3d3;
    }
  }

  + ul {
    position: absolute;
    left: 0;
    display: none;
    background-color: white;
    width: 100%;
    z-index: 9999;
    list-style: none;
    padding: 5px 10px 10px;
    &.visible {
      display: block;
      border-style: solid;
      border-width: 0 1px 1px 1px;
      border-color: #c8d0d6;
    }
    &.input-error {
      border-style: solid;
      border-width: 0 1px 1px 1px;
      border-color: #cc3333;
    }

    li {
      padding: 4px 0;
    }
  }
}

.multiselect {
  ::v-deep {
    input[type="checkbox"] {
      display: block;
      opacity: 0;

      &:focus + label::before {
        box-shadow: 0 0 0 1px lightgrey;
      }
    }
  }
}

// .input-error {
//   border: 1px solid #cc3333 !important;
// }
.height-auto {
  height: auto !important;
}
</style>
